<template>
  <el-container>
    <el-main>
      <el-row>
        <el-col :span="20">
          <el-form :inline="true">
            <el-form-item label="搜索模块">
              <el-input></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary">模块</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="4" style="text-align: right;">
          <el-button type="primary" @click="add">添加模块</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="app-card-group">
        <el-col :span="8">
          <el-card header="小区管理">
            <el-row>
              <el-col :span="6">
                <div class="nopic">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-col>
              <el-col :span="18">
                房产管理、绿化带管理、保洁管理、消防管理
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card header="业主管理">
            <el-row>
              <el-col :span="6">
                <div class="nopic">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-col>
              <el-col :span="18">
                房产管理、绿化带管理、保洁管理、消防管理
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card header="收费管理">
            <el-row>
              <el-col :span="6">
                <div class="nopic">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-col>
              <el-col :span="18">
                房产管理、绿化带管理、保洁管理、消防管理
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card header="来访登记">
            <el-row>
              <el-col :span="6">
                <div class="nopic">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-col>
              <el-col :span="18">
                房产管理、绿化带管理、保洁管理、消防管理
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card header="维修管理">
            <el-row>
              <el-col :span="6">
                <div class="nopic">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-col>
              <el-col :span="18">
                房产管理、绿化带管理、保洁管理、消防管理
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card header="生活服务">
            <el-row>
              <el-col :span="6">
                <div class="nopic">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-col>
              <el-col :span="18">
                房产管理、绿化带管理、保洁管理、消防管理
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card header="线上商城">
            <el-row>
              <el-col :span="6">
                <div class="nopic">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-col>
              <el-col :span="18">
                房产管理、绿化带管理、保洁管理、消防管理
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card header="公告通知">
            <el-row>
              <el-col :span="6">
                <div class="nopic">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-col>
              <el-col :span="18">
                房产管理、绿化带管理、保洁管理、消防管理
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card header="投诉建议">
            <el-row>
              <el-col :span="6">
                <div class="nopic">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-col>
              <el-col :span="18">
                房产管理、绿化带管理、保洁管理、消防管理
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card header="内容管理">
            <el-row>
              <el-col :span="6">
                <div class="nopic">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-col>
              <el-col :span="18">
                房产管理、绿化带管理、保洁管理、消防管理
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
    <el-dialog>

    </el-dialog>
  </el-container>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'Dashboard',
  data () {
    return {
      records: [
        {
          name: '智慧小区',
          contact: '黄*',
          mobile: '155***8888',
          started_at: '',
          expired_at: '',
          tips: 0,
          status: 0
        },
        {
          name: '智慧小区',
          contact: '张*',
          mobile: '188***8888',
          started_at: '2024-08-01',
          expired_at: '2025-08-01',
          tips: dayjs('2025-08-01').diff(dayjs(), 'day'),
          status: 1
        },
        {
          name: '高端小区',
          contact: '李*',
          mobile: '199***8888',
          started_at: '2025-05-01',
          expired_at: '2026-05-01',
          tips: dayjs('2026-05-01').diff(dayjs(), 'day'),
          status: 1
        },
        {
          name: '生活小区',
          contact: '王*',
          mobile: '177***8888',
          started_at: '2024-03-01',
          expired_at: '2025-03-01',
          tips: dayjs('2025-03-01').diff(dayjs(), 'day'),
          status: -1
        }
      ]
    }
  },
  mounted () {
    console.log(this.records)
  },
  methods: {
    add () {
      this.$confirm('此功能暂未开放?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        // this.$message({
        //   type: 'success',
        //   message: '删除成功!'
        // })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    }
  }
}
</script>

<style scoped>
.app-card-group .el-col:nth-child(n+4) {
  margin-top: 20px;
}
.nopic {
  font-size: 48px;
  color: #999;
}
</style>
